/**
 * Custom element that automatically attaches a shadow root from a template
 * Works with DOM morphing and dynamic content insertion
 * Uses data-html attribute to avoid parsing issues with malformed HTML
 */
class ShadowHostElement extends HTMLElement {
  connectedCallback() {
    // Only attach shadow root once
    if (this.shadowRoot) return;

    const templateId = this.getAttribute('template');
    if (!templateId) {
      console.warn('shadow-host: missing template attribute');
      return;
    }

    const template = document.getElementById(templateId);
    if (!template || !(template instanceof HTMLTemplateElement)) {
      console.warn(`shadow-host: template "${templateId}" not found`);
      return;
    }

    // Get the HTML content from the template's data attribute
    // This keeps it as a string to avoid parsing issues with malformed HTML
    const htmlContent = template.dataset.html;
    if (!htmlContent) {
      console.warn(`shadow-host: template "${templateId}" has no data-html attribute`);
      return;
    }

    // Attach shadow root and set content
    // The shadow root will parse and isolate the HTML, even if malformed
    const shadow = this.attachShadow({ mode: 'open' });
    shadow.innerHTML = htmlContent;
  }
}

if (!customElements.get('shadow-host')) {
  customElements.define('shadow-host', ShadowHostElement);
}
